/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */


import apiClient from './client';

export interface CompanyDomainInfo {
  companyName: string | null;
  domain: string | null;
  /** Zone the subdomain is created under: myezwheels.com (prod) / myezwheels-dev.com (dev). */
  baseDomain: string;
  fullDomain: string | null;
  /** Pending | Active | Failed — null when no domain is set. */
  status: string | null;
  /** false once the domain is provisioned (Active) — fields are locked. */
  canEdit: boolean;
}

export interface CreateDomainResult {
  result: boolean;
  domain: string;
  fullDomain: string;
  status: string;
}

export const ownerSiteApi = {
  getCompanyDomain: async (ownerId?: string): Promise<CompanyDomainInfo> => {
    const r = await apiClient.get<CompanyDomainInfo>('/owner-site/company-domain', {
      params: ownerId ? { ownerId } : undefined,
    });
    return r.data;
  },

  saveCompanyDomain: async (companyName: string, domain: string, ownerId?: string): Promise<void> => {
    await apiClient.put('/owner-site/company-domain',
      { companyName, domain },
      { params: ownerId ? { ownerId } : undefined },
    );
  },

  createDomain: async (companyName: string, domain: string, ownerId?: string): Promise<CreateDomainResult> => {
    const r = await apiClient.post<CreateDomainResult>('/owner-site/company-domain/create',
      { companyName, domain },
      { params: ownerId ? { ownerId } : undefined },
    );
    return r.data;
  },

  /** Current step of an in-flight create-domain call: 'dns' | 'binding' | 'ssl' | null. */
  getDomainProgress: async (ownerId?: string): Promise<string | null> => {
    const r = await apiClient.get<{ step: string | null }>('/owner-site/company-domain/progress', {
      params: ownerId ? { ownerId } : undefined,
    });
    return r.data?.step ?? null;
  },
};
